import { render, staticRenderFns } from "./OurShops.vue?vue&type=template&id=1321d91a&"
import script from "./OurShops.vue?vue&type=script&lang=js&"
export * from "./OurShops.vue?vue&type=script&lang=js&"
import style0 from "./OurShops.vue?vue&type=style&index=0&id=1321d91a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FullImgCard: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/FullImgCard.vue').default})
